import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Автомото туризм';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>Популярнейший сегодня вид отдыха, имеющий множество разновидностей и по сути, являющийся
                        разновидностью других видов туризма (экологического, оздоровительного и др.).</p>
                    <p><strong>Караваннинг</strong> – путешествие в небольших мобильных домиках на колесах.</p>
                </div>
            </div>
        </>
    );
}